import { render, staticRenderFns } from "./PillsAccent.vue?vue&type=template&id=2b57470a&"
import script from "./PillsAccent.vue?vue&type=script&lang=js&"
export * from "./PillsAccent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports